<div class="position-relative h-100 view-wrapper">
    <div class="header value">
        {{data.msg}}<button type="button" aria-label="Close" class="close" mat-dialog-close><span>×</span></button>
    </div>
    <!-- <div class="d-flex flex-column content-area h-100 justify-around">
        <div class="d-flex justify-between">
            <div class="d-flex flex-column pdr-10 flex1">
                <span class="key">Time</span>
                <span class="value">{{data?.item?.processedTime|date:'dd-MMM-y hh:mm:ss aaa':'en-US'}}</span>
            </div>
            <div class="d-flex flex-column mid-content flex1">
                <span class="key">Odometer(Km)</span>
                <span class="value">{{data?.item?.odometerValue}}</span>
            </div>
            <div class="d-flex flex-column pdl-10 flex1">
                <span class="key">RUL</span>
                <span class="value">{{data?.item?.rulValue}}</span>
            </div>
        </div>
        <div class="d-flex justify-between">
            <div class="d-flex flex-column pdr-10 flex1">
                <span class="key">Operation</span>
                <span class="value">{{data?.item?.operation | titlecase}}</span>
            </div>
            <div class="d-flex flex-column mid-content flex1">
                <span class="key">Type</span>
                <span class="value">{{data?.item?.type | titlecase}}</span>
            </div>
            <div class="d-flex flex-column pdl-10 flex1">
                <span class="key">Set By</span>
                <span class="value">{{user?user:'Model'}}</span>
            </div>
        </div>
    </div> -->
    <div class="d-flex view-responsive">
        <div class="d-flex content-area justify-around field-separetor" *ngFor="let elem of objectKeys(viewDetails)">
            <div class="d-flex flex-column flex1">
                <span class="key">{{elem}}</span>
                <div *ngIf="elem==='Time'">
                    {{viewDetails[elem]|date:'dd-MMM-y hh:mm:ss aaa':'en-US'}}
                </div>
                <div *ngIf="elem!=='Time'">
                    {{viewDetails[elem]}}
                </div>
            </div>
        </div>
    </div>
</div>